import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import { router } from './router';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
// import * as components from 'vuetify/components';
// import * as directives from 'vuetify/directives';
import { VDataTable } from 'vuetify/labs/VDataTable';
import * as Sentry from '@sentry/vue';

const vuetify = createVuetify({
  // components,
  // directives,
  components: {
    VDataTable,
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
});

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

Sentry.init({
  app,
  dsn: 'https://b8d8adf12c434cc88679741a1d22ebc0@o4505441895972864.ingest.sentry.io/4505441931427840',
  denyUrls: ['localhost'],
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [import.meta.env.VITE_APP_API_ENDPOINT],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

app.use(router);
app.use(vuetify);
app.use(pinia);
app.mount('#app');
